"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultBarShape = exports.DefaultBarShapeWithGap = void 0;
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
var Types_1 = require("../Types");
var BAR_SHAPE_OPACITY_ADJUST = (_a = {},
    _a[Types_1.BarShapeActiveStatus.Active] = 1.1,
    _a[Types_1.BarShapeActiveStatus.Inactive] = 0.4,
    _a[Types_1.BarShapeActiveStatus.Standard] = 1,
    _a);
function DefaultBarShapeWithGap(_a) {
    var shapeProps = _a.shapeProps, activeStatus = _a.activeStatus, _b = _a.opacity, opacity = _b === void 0 ? 0.9 : _b;
    var width = shapeProps.width, height = shapeProps.height, x = shapeProps.x, y = shapeProps.y, fill = shapeProps.fill, payload = shapeProps.payload;
    var pathBarShape = "M".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h -").concat(width, " Z");
    var pathGap = "M".concat(x, ",").concat(y, " h ").concat(width, " v 1 h -").concat(width, " Z");
    var opacityAdjusted = activeStatus ? opacity * BAR_SHAPE_OPACITY_ADJUST[activeStatus] : opacity;
    if (height === 0)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("path", { d: pathBarShape, width: width, height: height, x: x, y: y, fill: payload.color || fill, opacity: opacityAdjusted }),
        react_1.default.createElement("path", { d: pathGap, width: width, height: height, x: x, y: y, fill: "#fff" })));
}
exports.DefaultBarShapeWithGap = DefaultBarShapeWithGap;
function DefaultBarShape(_a) {
    var data = _a.data, activeStatus = _a.activeStatus, _b = _a.opacity, opacity = _b === void 0 ? 0.9 : _b;
    var xAxisName = data.xAxisName, color = data.color;
    var opacityAdjusted = activeStatus ? opacity * BAR_SHAPE_OPACITY_ADJUST[activeStatus] : opacity;
    if (color) {
        return react_1.default.createElement(recharts_1.Cell, { key: "cell-".concat(xAxisName, "-").concat(opacity), fill: color, opacity: opacityAdjusted });
    }
    return (react_1.default.createElement(recharts_1.Cell, { key: "cell-".concat(xAxisName, "-").concat(opacity), className: "chart__stacked-bar-default-color", opacity: opacityAdjusted }));
}
exports.DefaultBarShape = DefaultBarShape;
